import {ADDED_LOCATION} from "../actions/history_actions";

const history = (payload = [], action) => {
    switch (action.type) {
        case ADDED_LOCATION:
            payload = JSON.parse(JSON.stringify(payload));
            payload.unshift(action.payload);
    }

    return payload;
};

export default {
    history
}
